import NoodleAI from '@/components/Icons/NoodleAI';
import { FC } from 'react';
import { m } from 'framer-motion';
import s from './AILabel.module.scss';

const AILabel: FC<{
  label: string;
}> = ({ label }) => (
  <m.div className={s.label} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
    <NoodleAI />
    {label}
  </m.div>
);

export default AILabel;
